"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_rainbow_components_1 = require("react-rainbow-components");
var RequiredAsterisk_1 = __importDefault(require("react-rainbow-components/components/RequiredAsterisk"));
var errorText_1 = __importDefault(require("react-rainbow-components/components/Input/styled/errorText"));
var hooks_1 = require("@rainbow-modules/hooks");
var hooks_2 = require("react-rainbow-components/libs/hooks");
var styled_1 = require("./styled");
var UniversalPickerContext = react_1.createContext({});
function UniversalPicker(props) {
    var name = props.name, style = props.style, label = props.label, labelAlignment = props.labelAlignment, required = props.required, error = props.error, id = props.id, children = props.children, value = props.value, multiple = props.multiple, className = props.className, size = props.size, direction = props.direction, onChange = props.onChange;
    var nameUnique = hooks_1.useUniqueIdentifier('universal-picker');
    var groupName = name || nameUnique;
    var errorMessageId = hooks_2.useErrorMessageId(error);
    var handleChange = function (optionName, isChecked) {
        if (multiple) {
            if (Array.isArray(value)) {
                var currentValue_1 = isChecked
                    ? __spreadArrays(value, [optionName]) : value.filter(function (item) { return item !== optionName; });
                return onChange(currentValue_1);
            }
            var currentValue = isChecked ? [optionName] : [];
            return onChange(currentValue);
        }
        return onChange(optionName);
    };
    var context = {
        onChange: handleChange,
        value: value,
        multiple: multiple,
        ariaDescribedby: errorMessageId,
        groupName: groupName,
        size: size,
        error: error,
    };
    return (react_1.default.createElement(styled_1.StyledContainer, { id: id, className: className, style: style },
        react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: !!label },
            react_1.default.createElement(styled_1.StyledLabel, { labelAlignment: labelAlignment },
                react_1.default.createElement(RequiredAsterisk_1.default, { required: required }),
                label)),
        react_1.default.createElement(styled_1.StyledOptionsContainer, { direction: direction },
            react_1.default.createElement(UniversalPickerContext.Provider, { value: context }, children)),
        react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: !!error },
            react_1.default.createElement(errorText_1.default, { id: errorMessageId }, error))));
}
exports.default = UniversalPicker;
UniversalPicker.context = UniversalPickerContext;
UniversalPicker.propTypes = {
    /** The name of UniversalPicker. */
    name: prop_types_1.default.string,
    /** The value of the element. */
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.arrayOf(prop_types_1.default.string)]),
    /** If true then a multiple selection is allowed */
    multiple: prop_types_1.default.bool,
    /** The action triggered when a value attribute changes. */
    onChange: prop_types_1.default.func,
    /** If is set to true the UniversalPicker is required. This value defaults to false. */
    required: prop_types_1.default.bool,
    /** The title at the top of the UniversalPicker component. */
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    /** Describes the position of the UniversalPicker label. Options include left, center and right.
     * This value defaults to center. */
    labelAlignment: prop_types_1.default.oneOf(['left', 'center', 'right']),
    /** Specifies that an UniversalPicker must be filled out before submitting the form. */
    error: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    /** The size of the UniversalPicker. Valid values are small, medium, and large.
     * This value defaults to medium. */
    size: prop_types_1.default.oneOf(['small', 'medium', 'large']),
    /** The direction of the children. */
    direction: prop_types_1.default.oneOf(['horizontal', 'vertical']),
    /** The id of the outer element. */
    id: prop_types_1.default.string,
    /** The class name of the root element. */
    className: prop_types_1.default.string,
    /** It is an object with custom style applied to the root element. */
    style: prop_types_1.default.object,
    /**
     * This prop that should not be visible in the documentation.
     * @ignore
     */
    children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.object]),
};
UniversalPicker.defaultProps = {
    name: undefined,
    value: undefined,
    multiple: false,
    required: false,
    label: '',
    labelAlignment: 'center',
    error: null,
    size: 'medium',
    direction: 'horizontal',
    onChange: function () { },
    id: undefined,
    className: undefined,
    style: undefined,
    children: [],
};
//# sourceMappingURL=index.js.map